import React, { useState } from 'react'
import StockTakingList from './components/StockTakingList'
import CardHeadeWithActions from '../../components/ui/CardHeadeWithActions'
import { MwButton } from '../../components/ui'
import StockTakingForm from './components/StockTakingForm'
import AddStockTaking from './AddStockTaking'
import { useTranslation } from 'react-i18next'
import { LuLayoutDashboard } from 'react-icons/lu'

const StockTakingHome = () => {
        const [t,i18n ] = useTranslation('global')
        const [showAddForm, setShowAddForm] = useState(false);

    const [added,setAdded] = useState(false)

    return (
        <div className=''>
            <CardHeadeWithActions 
                title={<div className='flex items-center gap-2'>
                    <LuLayoutDashboard className="w-6 h-6"/> {t('stocktaking.warehouse_inventory')}
                </div>}
            >
                {showAddForm ? (
                    <MwButton 
                        type='saveBtn'
                        onClick={() => setShowAddForm(false)}
                    >
                        {t('stocktaking.return_to_list')}
                    </MwButton>
                ) : (
                    <MwButton 
                        type='saveBtn' 
                        onClick={() => setShowAddForm(true)}
                    >
                        {t('stocktaking.add_new_inventory')}
                    </MwButton>
                )}
            </CardHeadeWithActions>
            
            {showAddForm ? (
                <AddStockTaking 
                    setAdded={setAdded} 
                    setShowAddForm={setShowAddForm}
                />
            ) : (
                <StockTakingList added={added} />
            )}
        </div>
    );
}

export default StockTakingHome

 